// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-switcher {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.language-switcher ul {
  display: flex;
  gap: 0.25rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.language-switcher button {
  min-width: 2.25rem;
  padding: 0.35rem 0.5rem;
  border: 2px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.85);
  color: #333;
  font-size: 0.85rem;
  font-weight: bold;
  cursor: pointer;
}

.language-switcher button:hover {
  background: #fff;
}

.language-switcher button.active {
  background: #333;
  color: #fff;
  border-color: #333;
}

@media (max-width: 768px) {
  .language-switcher {
    top: 0.75rem;
    right: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LanguageSwitcher/LanguageSwitcher.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,qCAAqC;EACrC,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;IACZ,cAAc;EAChB;AACF","sourcesContent":[".language-switcher {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n}\n\n.language-switcher ul {\n  display: flex;\n  gap: 0.25rem;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.language-switcher button {\n  min-width: 2.25rem;\n  padding: 0.35rem 0.5rem;\n  border: 2px solid rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.85);\n  color: #333;\n  font-size: 0.85rem;\n  font-weight: bold;\n  cursor: pointer;\n}\n\n.language-switcher button:hover {\n  background: #fff;\n}\n\n.language-switcher button.active {\n  background: #333;\n  color: #fff;\n  border-color: #333;\n}\n\n@media (max-width: 768px) {\n  .language-switcher {\n    top: 0.75rem;\n    right: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
